import { USED } from '@/utils/constants/filters'
import {
  BUSINESS_TYPES,
} from './constants'

export default {
  name: 'oz-business-type',

  props: {
    currentFilters: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      businessValue: '',
      businessOptions: BUSINESS_TYPES,
    }
  },

  created () {
    const { business } = this.currentFilters

    this.businessValue = business
  },

  methods: {
    onChange (value) {
      this.$emit('filters:update', {
        business: value,
        listingType: USED,
        constructionStatus: '',
        warranties: '',
      })
    },
  },
}
